export const stepRequestMapper = ( data: any ) => {
  return {
    firstname: data?.summary?.firstname,
    surname: data?.summary?.surname,
    email: data?.summary?.email,
    phone: data?.summary?.phone,
    jobTitle: data?.summary?.jobTitle,
    companyName: data?.summary?.companyName,
    //companyRegistrationNumber: data?.summary?.companyRegistrationNumber,

    countryOfIncorporation: data?.company?.countryOfIncorporation,


    name: data?.company?.companyName,
    registrationNumber: data?.company?.registrationNumber,
    currency: data?.company?.currency,
    fundingRequired: data?.company?.fundingRequired,
    businessModel: data?.company?.businessModel,
    turnover: data?.company?.turnover,
    forecastTurnover: data?.company?.forecastTurnover,
    comments: data?.company?.comments,

    /*  selectedProducts: data?.company?.selectedProducts || [],
        netProfitAndLoss12Months: data?.company?.netProfitAndLoss12Months,
        forecastNetProfitLoss12Months: data?.company?.forecastNetProfitLoss12Months,*/

  };
};


export const stepRequestMapperWithoutEmail = ( data: any ) => {
  return {
    firstname: data?.summary?.firstname,
    surname: data?.summary?.surname,
    phone: data?.summary?.phone,
    jobTitle: data?.summary?.jobTitle,
    companyName: data?.summary?.companyName,
    countryOfIncorporation: data?.summary?.countryOfIncorporation,
  };
};